import LuckyDraw from './LuckyDraw';

export default LuckyDraw



// WEBPACK FOOTER //
// ./src/LuckyDraw/index.js